import qs from 'qs'
import { initializeI18n } from './locales'
import ActionSlot from 'slots/ActionSlot'
import { Provider } from 'react-redux'
import { buildStore } from 'store'
import UISlot from 'slots/UISlot'
import { createBrowserHistory } from 'history'
import PostPaymentSlot from 'slots/PostPaymentSlot'
import SettingsSlot from 'slots/SettingsSlot'
import BuyerFacingDisplaySlot from './slots/BuyerFacingDisplaySlot'

initializeI18n()

enum Slot {
  ACTION,
  PAY,
  POST_PAY,
  SETTINGS,
  UI,
  BUYER_FACING_DISPLAY,
}

enum SlotQueryParamValues {
  ACTION = 'action',
  PAY = 'pay',
  POST_PAY = 'postpayment',
  SETTINGS = 'settings',
  BUYER_FACING_DISPLAY = 'verifycustomer',
}

const store = buildStore()
const browserHistory = createBrowserHistory()

function App() {
  const slot: Slot = getSlot()

  // @ts-ignore
  window.slot = slot

  const getScreen = (slot: Slot) => {
    switch (slot) {
      case Slot.ACTION:
        return <ActionSlot />

      case Slot.POST_PAY:
        return (
          <Provider store={store}>
            <PostPaymentSlot />
          </Provider>
        )

      case Slot.SETTINGS:
        return <SettingsSlot />

      case Slot.PAY:
      case Slot.UI:
        return (
          <Provider store={store}>
            <UISlot browserHistory={browserHistory} />
          </Provider>
        )

      case Slot.BUYER_FACING_DISPLAY:
        return (
          <Provider store={store}>
            <BuyerFacingDisplaySlot />
          </Provider>
        )

      default:
        return <></>
    }
  }

  return <div data-testid={`slot-${slot}`}>{getScreen(slot)}</div>
}

const SLOT_QUERY_PARAM_KEY = 'slot'

function getSlot(): Slot {
  const queryParams = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  })
  const slotQueryParam = queryParams[SLOT_QUERY_PARAM_KEY]

  switch (slotQueryParam) {
    case SlotQueryParamValues.ACTION:
      return Slot.ACTION
    case SlotQueryParamValues.PAY:
      return Slot.PAY
    case SlotQueryParamValues.POST_PAY:
      return Slot.POST_PAY
    case SlotQueryParamValues.SETTINGS:
      return Slot.SETTINGS
    case SlotQueryParamValues.BUYER_FACING_DISPLAY:
      return Slot.BUYER_FACING_DISPLAY
    default:
      return Slot.UI
  }
}

export default App
